import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admin-tools"
export default class extends Controller {
	static values = { title: String, prompt: String };

	toggle() {
		this.element.classList.add("hidden");
	}

	confirmDelete(event) {
		const input = prompt(`${this.promptValue}\n\n${this.titleValue}`);
		if (input !== this.titleValue) {
			event.preventDefault();
		}
	}
}
